import { useEffect, useRef } from 'react';

export const useAutoLogoutOnInactivity = (onIdle: () => void, timeoutSpeed = 10 * 60 * 60 * 1000) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      console.log('[auto-logout] Session expired due to inactivity');
      onIdle();
    }, timeoutSpeed);
  };

  useEffect(() => {
    // List of events that reset the inactivity timer
    const events = ['mousemove', 'mousedown', 'click', 'scroll', 'keypress', 'touchstart', 'touchmove'];

    // Initialize timer on mount
    resetTimer();

    // Add event listeners to the window
    events.forEach((event) => window.addEventListener(event, resetTimer, { passive: true }));

    // Cleanup listeners and timers on unmount
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [onIdle, timeoutSpeed]);
};

export default useAutoLogoutOnInactivity;
